import { call, put, takeLeading } from 'redux-saga/effects'
import { ICourseModel } from 'models/course.model'
import getCourse from 'api/administration/courses/Get'
import { onHttpError } from 'helpers/access.helper'
import * as fromActions from '../../actions/courses.action'

async function handleGetCourse(courseId: number) {
  return getCourse(courseId)
}

function* getCourseEffectSaga(action: any) {
  try {
    const data: ICourseModel = yield call(handleGetCourse, action.payload)
    yield put(fromActions.Actions.getCourseSuccess(data))
  } catch (error) {
    onHttpError(error)
    yield put(fromActions.Actions.setCourseLoading(false))
    console.log('error: ', error)
  }
}

export function* getAdminCourseWatcherSaga() {
  yield takeLeading(fromActions.GET_ADMIN_COURSE, getCourseEffectSaga)
}
